import { districtToZips } from './zipMapping';

const zipToDistrictMap = {}
for (const dist in districtToZips) {
    let zips = districtToZips[dist]
    let distName = dist;
    switch(dist) {
        case 'DC_GROWING':
        case 'LA_GROWING':
        case 'NYC_GROWING':
            distName = 'DEFAULT'
            break;
        default:
    }
    zips.forEach((zip) => {
        zipToDistrictMap[zip] = distName
    })
}

export default (zip) => zipToDistrictMap[zip];



// WEBPACK FOOTER //
// ./src/helpers/zipToDistrict.js